
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
} from '@mui/x-data-grid';
import Box from "@mui/material/Box";

import {
    Avatar,
    Tooltip
} from "@mui/material";

// App Imports
import {getContractStatsMarketGroup} from "../../Contract/ContractClient";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import {changeContractStats} from "./contractStatsSlice";
import {changeContractStatsControls} from "./contractStatsControlsSlice";
import {StatsMenu} from "./StatsMenu";


// main function
export default function MarketGroupContractStatsGrid() {

    // ****************** BEGIN STATES ****************************

    const [marketGroupContractStats, setMarketGroupContractStats] = useState([]);
    const [gridVisible, setGridVisible] = React.useState(true);


    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************


    const hideActions = localStorage.getItem('hideActions') === "true";
    const dispatchData = useDispatch();

    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************

    const fetchMarketGroupContractStats = () =>
        getContractStatsMarketGroup()

            .then(data => {
                console.log(data);
                setMarketGroupContractStats(data);
            })
    useEffect(() => {
        fetchMarketGroupContractStats();
    }, []);

    // ****************** END FETCH ****************************


    const renderMarketGroupContractStats = marketGroupContractStats => {
        if (marketGroupContractStats.length <= 0) {
            return "No Data";
        }}


    // ****************** BEGIN CRUD ***********************************



    // ****************** END CRUD ***********************************



    // ****************** BEGIN DRILLDOWN ****************************

    // ****************** END DRILLDOWN ****************************

    const handleClickedRow = (marketGroupContractStats) => {

        console.log('Stats data from clicked row');
        console.log(marketGroupContractStats);
        dispatchData(changeContractStats({marketGroupId: marketGroupContractStats.marketGroupId, marketGroupName: marketGroupContractStats.marketGroupName,
            releaseMarketId: null, releaseMarketName: null,
            seriesId: null, seriesName: null, seasonId: null, seasonName: null, productId: null, episodeName: null, photoStartDate: null}));
        dispatchData(changeContractStatsControls({gridDisplay: "ReleaseMarketFullScreen"}));
    };





    // ****************** BEGIN COLUMNS ****************************

    const columns = marketGroupContractStats => [

        {    field: 'more',
            headerName: '',
            description: '',
            sortable: true,
            width: 60,
            hide: false,
            renderCell: (params) => (
                <div onClick={(event) => event.stopPropagation()}>
                    <StatsMenu row={params.row}  />
                </div>
            )
        },
        {    field: 'id',
            headerName: 'ID',
            description: '',
            sortable: true,
            width: 60,
            hide: true,
        },
        {
            field: 'm4mktGroupName',
            headerName: 'Market Group',
            description: '',
            sortable: true,
            editable: true,
            hide: false,
            // editable: true,
            width: 220,
        },
        {
            field: 'm4mktGroupId',
            headerName: 'Market Group ID',
            description: '',
            sortable: false,
            editable: false,
            width: 100,
            hide: true,
        },
        {
            field: 'standAloneCount',
            headerName: 'Stand Alone',
            width: 100,
            headerAlign: 'center',
            renderCell: (marketGroupContractStats) => {
                const count = marketGroupContractStats.row.standAloneCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                    <Tooltip title="Count of stand alone products with contracts.">
                        <Avatar variant="rounded" sx={{
                            height: 20,
                            width,
                            fontSize: 16,
                            backgroundColor: "rgb(30,144,255)",
                            color: "rgb(255, 255, 255)"
                        }}>
                            {count}
                        </Avatar>
                    </Tooltip>
                    </Box>
                );
            }
        },
        {
            field: 'seriesCount',
            headerName: 'Series',
            headerAlign: 'center',
            width: 100,
            renderCell: (marketGroupContractStats) => {
                const count = marketGroupContractStats.row.seriesCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of series with contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        {
            field: 'seasonCount',
            headerName: 'Seasons',
            headerAlign: 'center',
            width: 100,
            renderCell: (marketGroupContractStats) => {
                const count = marketGroupContractStats.row.seasonCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of seasons with contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        {
            field: 'episodeCount',
            headerName: 'Episodes',
            headerAlign: 'center',
            width: 100,
            renderCell: (marketGroupContractStats) => {
                const count = marketGroupContractStats.row.episodeCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of episodes with contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        {
            field: 'products',
            headerName: 'Products',
            headerAlign: 'center',
            width: 100,
            renderCell: (marketGroupContractStats) => {
                const count = marketGroupContractStats.row.productCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of episodes with contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },

        {
            field: 'guildCount',
            headerName: 'Guilds',
            width: 100,
            headerAlign: 'center',
            renderCell: (marketGroupContractStats) => {
                const count = marketGroupContractStats.row.guildCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of guild contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },

        {
            field: 'guilds',
            headerName: 'Guilds',
            description: '',
            sortable: true,
            editable: false,
            hide: false,
            // editable: true,
            width: 380,
        },
        {
            field: 'approvedCount',
            headerName: 'Approved',
            width: 100,
            headerAlign: 'center',
            renderCell: (marketGroupContractStats) => {
                const count = marketGroupContractStats.row.approvedCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of approved contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        {
            field: 'unapprovedCount',
            headerName: 'Unapproved',
            width: 100,
            headerAlign: 'center',
            renderCell: (marketGroupContractStats) => {
                const count = marketGroupContractStats.row.unapprovedCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of unapproved contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                // backgroundColor: "rgb(30,144,255)",
                                backgroundColor: "warning.main",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },

    ];

    // ****************** END COLUMNS ****************************


    // ****************** BEGIN TOOLBAR ****************************



    // ****************** END TOOLBAR ****************************

    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: '100%' }}>
            <Box sx={{height: 70, pt: 1, pl: 3}}>
                <h3>Made-For Market Group Contract Statistics</h3>
            </Box>
            {gridVisible && <DataGrid
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                style={{cursor: 'pointer'}}
                aria-label={"MarketGroupContractStats"}
                rows={marketGroupContractStats}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={columns(fetchMarketGroupContractStats)}
                onRowClick = {(marketGroupContractStats)=>handleClickedRow(marketGroupContractStats.row)}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={marketGroupContractStat => marketGroupContractStat.id}
                components={{
                    // Toolbar: CustomToolbar,
                    Footer: CustomFooter,
                }}
            />}
        </div>
    );

    // ****************** END RETURN ****************************

}

